<!-- Inspetor Aprimorado com Melhorias de UI V5 -->
<div class="inspector-container">
    <div class="component-header" *ngIf="selectedComponentType">
      <div class="component-info">
        <nz-tag [nzColor]="'blue'" style="margin: 0;">
          <nz-icon nzType="build" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.componentTypes.' + selectedComponentType |translateTA }}
        </nz-tag>
      </div>
      <div class="quick-actions">
        <button nz-button nzType="text" nzSize="small" nzShape="circle"
          (click)="moveComponentUp()" nz-tooltip [nzTooltipTitle]="'builderScreen.common.moveUp' | translateTA">
          <nz-icon nzType="arrow-up"></nz-icon>
        </button>
        <button nz-button nzType="text" nzSize="small" nzShape="circle"
          (click)="moveComponentDown()" nz-tooltip [nzTooltipTitle]="'builderScreen.common.moveDown' | translateTA">
          <nz-icon nzType="arrow-down"></nz-icon>
        </button>
        <button *ngIf="canImportFields" nz-button nzType="text" nzSize="small" nzShape="circle"
          (click)="openImportFieldsModal()" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.importFields' | translateTA">
          <nz-icon nzType="import"></nz-icon>
        </button>
        <button nz-button nzType="text" nzSize="small" nzShape="circle"
          (click)="copyComponentConfig()" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.copyConfig' | translateTA">
          <nz-icon nzType="copy"></nz-icon>
        </button>
        <button nz-button nzType="text" nzSize="small" nzShape="circle" nzDanger
          (click)="deleteSelectedComponent()" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.removeComponent' | translateTA">
          <nz-icon nzType="delete"></nz-icon>
        </button>
        <button *ngIf="componentPresets.length > 0" nz-button nzType="text" nzSize="small" nzShape="circle"
          (click)="togglePresetSelector()" nz-tooltip
          [nzTooltipTitle]="'builderScreen.inspector.presets.tooltip' |translateTA">
          <nz-icon nzType="thunderbolt"></nz-icon>
        </button>
      </div>
    </div>
  
    <!-- Painel do Seletor de Preset -->
    <nz-card 
      *ngIf="showPresetSelector && componentPresets.length > 0" 
      [nzSize]="'small'" 
      [nzTitle]="'builderScreen.inspector.presets.title' |translateTA"
      class="preset-selector">
      
      <div class="preset-grid">
        <div 
          *ngFor="let preset of componentPresets" 
          class="preset-item"
          (click)="applyPreset(preset.id)"
          nz-tooltip
          [nzTooltipTitle]="preset.description">
          
          <div class="preset-name">{{ preset.name }}</div>
          <div class="preset-description">{{ preset.description }}</div>
        </div>
      </div>
      
      <div class="preset-actions">
        <button nz-button nzType="text" nzSize="small" (click)="togglePresetSelector()">
          {{ 'builderScreen.inspector.presets.cancel' |translateTA }}
        </button>
      </div>
    </nz-card>
  
    <!-- Busca rápida de propriedades -->
    <div class="inspector-search" *ngIf="selectedComponentType">
      <nz-input-group [nzPrefix]="searchIcon" nzSize="small" [nzSuffix]="searchClear">
        <input nz-input [placeholder]="'builderScreen.inspector.searchPlaceholder' | translateTA"
          [(ngModel)]="inspectorSearchTerm"
          (ngModelChange)="onInspectorSearch($event)" />
      </nz-input-group>
      <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
      <ng-template #searchClear>
        <nz-icon *ngIf="inspectorSearchTerm" nzType="close-circle" nzTheme="fill"
          style="cursor: pointer; color: #bfbfbf;" (click)="inspectorSearchTerm = ''; onInspectorSearch('')"></nz-icon>
      </ng-template>
    </div>

    <!-- Formulário Principal do Inspetor -->
    <form [formGroup]="form" nz-form *ngIf="selectedComponentType && form">
      <nz-collapse [nzBordered]="false">
        
        <!-- Configurações Essenciais (Sempre Visíveis) -->
        <nz-collapse-panel 
          [nzHeader]="'builderScreen.inspector.essentials' |translateTA" 
          [nzActive]="true"
          [nzDisabled]="false">
          
          <ng-template #essentialContent>
            <div class="properties-grid">
              <!-- Propriedades Essenciais Dinâmicas -->
              <div *ngFor="let property of essentialProperties" class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="property.key === 'required'">
                    <span class="property-label">
                      {{ property.labelKey |translateTA }}
                      <nz-icon 
                        *ngIf="property.helpTextKey" 
                        nzType="question-circle" 
                        nz-tooltip 
                        [nzTooltipTitle]="property.helpTextKey |translateTA"
                        class="help-icon">
                      </nz-icon>
                    </span>
                  </nz-form-label>
                  
                  <nz-form-control [nzSpan]="24">
                    <!-- Campo de Texto -->
                    <input 
                      *ngIf="property.type === 'text'" 
                      nz-input 
                      [formControlName]="property.key" 
                      (blur)="onBlur(property.key)"
                      [placeholder]="property.labelKey + '.placeholder' |translateTA" />
                    
                    <!-- Área de Texto -->
                    <textarea 
                      *ngIf="property.type === 'textarea'" 
                      nz-input 
                      [formControlName]="property.key" 
                      (blur)="onBlur(property.key)"
                      [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                      [placeholder]="property.labelKey + '.placeholder' |translateTA">
                    </textarea>
                    
                    <!-- Campo Numérico -->
                    <nz-input-number 
                      *ngIf="property.type === 'number'" 
                      [formControlName]="property.key"
                      [nzMin]="property.min"
                      [nzMax]="property.max"
                      [nzStep]="property.step || 1"
                      (nzBlur)="onBlur(property.key)"
                      style="width: 100%">
                    </nz-input-number>
                    
                    <!-- Caixa de Seleção -->
                    <label 
                      *ngIf="property.type === 'checkbox'" 
                      nz-checkbox 
                      [formControlName]="property.key">
                      {{ property.labelKey |translateTA }}
                    </label>
                    
                    <!-- Seletor -->
                    <nz-select 
                      *ngIf="property.type === 'select'" 
                      [formControlName]="property.key"
                      (ngModelChange)="onBlur(property.key)">
                      <nz-option 
                        *ngFor="let option of property.options" 
                        [nzValue]="option.value" 
                        [nzLabel]="option.label">
                      </nz-option>
                    </nz-select>
                    
                    <!-- Seletor de Cor -->
                    <input 
                      *ngIf="property.type === 'color'" 
                      type="color" 
                      nz-input 
                      [formControlName]="property.key" 
                      (blur)="onBlur(property.key)" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
  
            <!-- Ordem de exibição inline (compacto) -->
            <div *ngIf="selectedComponentType !== 'tabs'" style="margin-top: 8px; display: flex; align-items: center; gap: 8px;">
              <span style="font-size: 12px; color: #8c8c8c; white-space: nowrap;">
                Ordem
                <nz-icon nzType="question-circle" nz-tooltip
                  [nzTooltipTitle]="'builderScreen.inspector.orderHelp' | translateTA"
                  style="margin-left: 4px; cursor: help;"></nz-icon>
              </span>
              <nz-input-number
                formControlName="order"
                [nzMin]="0" [nzMax]="100" [nzStep]="1"
                (nzBlur)="onBlur('order')"
                style="width: 70px;"
                nzSize="small"
                nzPlaceHolder="0">
              </nz-input-number>
            </div>
  
            <!-- ⭐ NOVO: Data Binding (para preencher campos automaticamente) -->
            <div *ngIf="selectedComponentType !== 'tabs' && selectedComponentType !== 'panel' && selectedComponentType !== 'datagrid' && selectedComponentType !== 'spreadsheet' && selectedComponentType !== 'row'" 
                 class="properties-grid" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.inspector.dataSection' | translateTA"></nz-divider>
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    Campo no JSON (Path)
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.dataPathHelp2' | translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input 
                      nz-input 
                      formControlName="dataPath"
                      [placeholder]="'builderScreen.inspector.dataPathPlaceholder' | translateTA"
                      (blur)="onBlur('dataPath')">
                  </nz-form-control>
                </nz-form-item>
              </div>
              
              <!-- Preview do valor atual (se houver dados) -->
              <div class="property-item" *ngIf="dataPathPreview">
                <nz-alert 
                  nzType="info" 
                  [nzMessage]="'Valor atual: ' + dataPathPreview"
                  nzShowIcon>
                </nz-alert>
              </div>
            </div>
  
            <!-- Controles específicos de QuerySelect -->
            <div *ngIf="selectedComponentType === 'querySelect'" class="properties-grid">
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    <span>{{ 'builderScreen.querySelect.properties.condition' |translateTA }}</span>
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.querySelect.properties.condition.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input 
                      nz-input 
                      formControlName="condition" 
                      (blur)="onBlur('condition')"
                      [placeholder]="'builderScreen.querySelect.properties.condition.placeholder' |translateTA" />
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <!-- ⭐ Botão para aplicar configurações -->
              <div class="property-item" style="grid-column: 1 / -1;">
                <button 
                  nz-button 
                  nzType="primary"
                  nzBlock
                  (click)="forceComponentReload()"
                  style="margin-top: 16px;">
                  <nz-icon nzType="reload"></nz-icon>
                  Aplicar Configurações
                </button>
                <nz-form-extra style="margin-top: 8px; text-align: center; font-size: 12px;">
                  Clique para aplicar as alterações e recarregar o componente
                </nz-form-extra>
              </div>
            </div>
  
            <!-- Controles específicos de Search -->
            <div *ngIf="selectedComponentType === 'search'" class="properties-grid">
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    <span>{{ 'builderScreen.search.properties.entityName' |translateTA }}</span>
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.search.properties.entityName.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input 
                      nz-input 
                      formControlName="searchEntityName" 
                      (blur)="onBlur('searchEntityName')"
                      [placeholder]="'builderScreen.search.properties.entityName.placeholder' |translateTA" />
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    <span>{{ 'builderScreen.search.properties.keyField' |translateTA }}</span>
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.search.properties.keyField.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input 
                      nz-input 
                      formControlName="searchKeyField" 
                      (blur)="onBlur('searchKeyField')"
                      [placeholder]="'builderScreen.search.properties.keyField.placeholder' |translateTA" />
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    <span>{{ 'builderScreen.search.properties.valueField' |translateTA }}</span>
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.search.properties.valueField.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input 
                      nz-input 
                      formControlName="searchValueField" 
                      (blur)="onBlur('searchValueField')"
                      [placeholder]="'builderScreen.search.properties.valueField.placeholder' |translateTA" />
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    <span>{{ 'builderScreen.search.properties.showKey' |translateTA }}</span>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <label nz-checkbox formControlName="showKey">
                      {{ 'builderScreen.search.properties.showKey.label' |translateTA }}
                    </label>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <app-inspector-dependencies
                [helpText]="'builderScreen.inspector.dependencyHelp' | translateTA"
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>

              <!-- Botão para aplicar configurações -->
              <div class="property-item" style="grid-column: 1 / -1;">
                <button 
                  nz-button 
                  nzType="primary"
                  nzBlock
                  (click)="forceComponentReload()"
                  style="margin-top: 16px;">
                  <nz-icon nzType="reload"></nz-icon>
                  Aplicar Configurações
                </button>
                <nz-form-extra style="margin-top: 8px; text-align: center; font-size: 12px;">
                  Clique para aplicar as alterações e recarregar o componente
                </nz-form-extra>
              </div>
            </div>
  
            <!-- Controles específicos do botão -->
            <div *ngIf="selectedComponentType === 'button'" class="properties-grid">
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.button.properties.text' |translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input nz-input formControlName="text" [placeholder]="'builderScreen.button.defaultText' |translateTA" />
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.button.properties.buttonType' |translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="buttonType">
                      <nz-option nzValue="default" [nzLabel]="'builderScreen.common.default' | translateTA"></nz-option>
                      <nz-option nzValue="primary" [nzLabel]="'builderScreen.inspector.buttonType.primary' | translateTA"></nz-option>
                      <nz-option nzValue="dashed" [nzLabel]="'builderScreen.inspector.buttonType.dashed' | translateTA"></nz-option>
                      <nz-option nzValue="text" [nzLabel]="'builderScreen.common.text' | translateTA"></nz-option>
                      <nz-option nzValue="link" [nzLabel]="'builderScreen.inspector.buttonType.link' | translateTA"></nz-option>
                      <nz-option nzValue="danger" [nzLabel]="'builderScreen.inspector.buttonType.danger' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.button.properties.size' |translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="size">
                      <nz-option nzValue="small" [nzLabel]="'builderScreen.common.size.small' | translateTA"></nz-option>
                      <nz-option nzValue="default" [nzLabel]="'builderScreen.common.default' | translateTA"></nz-option>
                      <nz-option nzValue="large" [nzLabel]="'builderScreen.common.size.large' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.button.properties.actionType' |translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="actionType">
                      <nz-option nzValue="save" nzLabel="{{ 'builderScreen.button.actionType.save' |translateTA }}"></nz-option>
                      <nz-option nzValue="cancel" nzLabel="{{ 'builderScreen.button.actionType.cancel' |translateTA }}"></nz-option>
                      <nz-option nzValue="custom" nzLabel="{{ 'builderScreen.button.actionType.custom' |translateTA }}"></nz-option>
                      <nz-option nzValue="flow" [nzLabel]="'builderScreen.inspector.action.runFlow' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <!-- Configuração de Fluxo (quando actionType === 'flow') -->
              <ng-container *ngIf="form.get('actionType')?.value === 'flow'">
                <nz-divider [nzText]="'builderScreen.inspector.flowSection' | translateTA" nzOrientation="left"></nz-divider>
                
                <div class="property-item">
                  <button nz-button nzType="dashed" nzBlock (click)="openFlowConfigModal()">
                    <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
                    Configurar Fluxo
                  </button>
                  
                  <!-- Preview da configuração atual -->
                  <div class="flow-config-preview" *ngIf="form.get('flowConfig.idConf')?.value">
                    <div class="preview-item">
                      <span class="preview-label">Config:</span>
                      <span class="preview-value">
                        #{{ form.get('flowConfig.idConf')?.value }}
                        <span *ngIf="form.get('flowConfig.confName')?.value"> - {{ form.get('flowConfig.confName')?.value }}</span>
                      </span>
                    </div>
                    <div class="preview-item">
                      <nz-tag [nzColor]="form.get('flowConfig.newMode')?.value ? 'green' : 'default'">
                        {{ form.get('flowConfig.newMode')?.value ? 'Fluxo novo (assíncrono)' : 'Fluxo antigo' }}
                      </nz-tag>
                    </div>
                    <div class="preview-item" *ngIf="form.get('flowConfig.showCodeCompany')?.value">
                      <nz-tag nzColor="blue">{{ 'builderScreen.inspector.companySelectionOn' | translateTA }}</nz-tag>
                    </div>
                    <div class="preview-item" *ngIf="!form.get('flowConfig.showCodeCompany')?.value && form.get('flowConfig.codeCompany')?.value">
                      <span class="preview-label">Empresa fixa:</span>
                      <span class="preview-value">{{ form.get('flowConfig.codeCompany')?.value }}</span>
                    </div>
                  </div>
                </div>
                
                <!-- Modo de Envio de Dados (quando actionType === 'flow') -->
                <div class="property-item">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24">
                      {{ 'builderScreen.inspector.button.flowDataMode' | translateTA }}
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <nz-select formControlName="flowDataMode" style="width: 100%;">
                        <nz-option 
                          nzValue="full" 
                          [nzLabel]="'builderScreen.inspector.button.flowDataMode.full' | translateTA">
                        </nz-option>
                        <nz-option 
                          nzValue="selectedItem" 
                          [nzLabel]="'builderScreen.inspector.button.flowDataMode.selectedItem' | translateTA">
                        </nz-option>
                      </nz-select>
                    </nz-form-control>
                    <nz-form-extra>
                      {{ 'builderScreen.inspector.button.flowDataMode.help' | translateTA }}
                    </nz-form-extra>
                  </nz-form-item>
                </div>
              </ng-container>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.button.properties.icon' |translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input nz-input formControlName="icon" placeholder="plus, edit, delete..." />
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <!-- Seção de Cores do Botão -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-title">{{ 'builderScreen.button.section.colors' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.button.properties.backgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="backgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('backgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.button.properties.textColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="textColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('textColor')">
                    </nz-color-picker>
                  </div>
                </div>
              </div>
  
              <div class="inline-toggle-group">
                <div class="inline-toggle-item">
                  <label nz-checkbox formControlName="disabled">
                    {{ 'builderScreen.button.properties.disabled' |translateTA }}
                  </label>
                </div>
                <div class="inline-toggle-item">
                  <label nz-checkbox formControlName="loading">
                    {{ 'builderScreen.button.properties.loading' |translateTA }}
                  </label>
                </div>
              </div>
            </div>
  
            <!-- Controles específicos da imagem -->
            <div *ngIf="selectedComponentType === 'image'" class="properties-grid">
              <nz-divider [nzText]="'builderScreen.inspector.imageSection' | translateTA" nzOrientation="left"></nz-divider>
              
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.imageUrl' |translateTA }}
                    <nz-icon nzType="question-circle" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.imageUrl.help' |translateTA" class="help-icon"></nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <textarea nz-input 
                      formControlName="imageUrl" 
                      [placeholder]="'builderScreen.inspector.imageUrl.placeholder' |translateTA"
                      [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                      (blur)="onBlur('imageUrl')">
                    </textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.alt' |translateTA }}
                    <nz-icon nzType="question-circle" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.alt.help' |translateTA" class="help-icon"></nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input nz-input formControlName="alt" [placeholder]="'builderScreen.inspector.placeholder.image' | translateTA" (blur)="onBlur('alt')">
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.width' |translateTA }}
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-input-number 
                      formControlName="width" 
                      [nzMin]="0" 
                      [nzMax]="2000" 
                      [nzStep]="10"
                      (nzBlur)="onBlur('width')">
                    </nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.height' |translateTA }}
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-input-number 
                      formControlName="height" 
                      [nzMin]="0" 
                      [nzMax]="2000" 
                      [nzStep]="10"
                      (nzBlur)="onBlur('height')">
                    </nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.borderRadius' |translateTA }}
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-input-number 
                      formControlName="borderRadius" 
                      [nzMin]="0" 
                      [nzMax]="100" 
                      [nzStep]="1"
                      (nzBlur)="onBlur('borderRadius')">
                    </nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-control [nzSpan]="24">
                    <label nz-checkbox formControlName="enableLightbox" (ngModelChange)="onBlur('enableLightbox')">
                      {{ 'builderScreen.inspector.enableLightbox' |translateTA }}
                      <nz-icon nzType="question-circle" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.enableLightbox.help' |translateTA" class="help-icon"></nz-icon>
                    </label>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
  
            <!-- Controles específicos do texto -->
            <div *ngIf="selectedComponentType === 'text'" class="properties-grid">
              <!-- Valor Padrão -->
              <div class="property-item full-width">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.defaultValue' |translateTA }}
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.defaultValue.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input nz-input formControlName="defaultValueText" 
                      [placeholder]="'builderScreen.inspector.defaultValue.placeholder' |translateTA" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div class="color-grid" style="grid-column: 1 / -1;">
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.text.properties.backgroundColor' |translateTA }}</label>
                  <nz-color-picker formControlName="backgroundColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.text.properties.textColor' |translateTA }}</label>
                  <nz-color-picker formControlName="textColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
              </div>

              <app-inspector-dependencies
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>
            </div>
  
            <!-- Controles específicos da área de texto -->
            <div *ngIf="selectedComponentType === 'textarea'" class="properties-grid">
              <!-- Valor Padrão -->
              <div class="property-item full-width">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.defaultValue' |translateTA }}
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.defaultValue.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <textarea nz-input formControlName="defaultValueText" 
                      [nzAutosize]="{ minRows: 2, maxRows: 4 }"
                      [placeholder]="'builderScreen.inspector.defaultValue.placeholder' |translateTA">
                    </textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div class="color-grid" style="grid-column: 1 / -1;">
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.textarea.properties.backgroundColor' |translateTA }}</label>
                  <nz-color-picker formControlName="backgroundColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.textarea.properties.textColor' |translateTA }}</label>
                  <nz-color-picker formControlName="textColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
              </div>

              <app-inspector-dependencies
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>
            </div>
  
            <!-- Controles específicos do número -->
            <div *ngIf="selectedComponentType === 'number'" class="properties-grid">
              <!-- Valor Padrão -->
              <div class="property-item full-width">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.defaultValue' |translateTA }}
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.defaultValue.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-input-number
                      formControlName="defaultValueNumber"
                      [nzPlaceHolder]="'builderScreen.inspector.defaultValue.placeholder' |translateTA"
                      [style.width.%]="100">
                    </nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div class="color-grid" style="grid-column: 1 / -1;">
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.number.properties.backgroundColor' |translateTA }}</label>
                  <nz-color-picker formControlName="backgroundColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.number.properties.textColor' |translateTA }}</label>
                  <nz-color-picker formControlName="textColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
              </div>
            </div>

            <!-- NOVO: Configuração de Formatação do Number -->
            <div *ngIf="selectedComponentType === 'number'" class="number-format-section-simple" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.inspector.numberFormatTitle' | translateTA"></nz-divider>
              
              <div class="number-format-simple">
                <!-- Botão para abrir modal -->
                <button 
                  nz-button 
                  nzType="default" 
                  nzBlock
                  (click)="openNumberFormatModal()"
                  class="config-format-btn">
                  <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
                  {{ 'builderScreen.inspector.numberFormatModal.openButton' | translateTA }}
                </button>
                
                <!-- Preview da configuração atual -->
                <div class="format-summary">
                  <div class="format-info">
                    <nz-icon nzType="info-circle" nzTheme="twotone" [nzTwotoneColor]="'#1890ff'"></nz-icon>
                    <span>
                      {{ form.get('decimalPlaces')?.value || 2 }} {{ 'builderScreen.inspector.numberFormatModal.decimalPlacesShort' | translateTA }}
                      <ng-container *ngIf="form.get('formatThousands')?.value">
                        , {{ 'builderScreen.inspector.numberFormatModal.withThousands' | translateTA }}
                      </ng-container>
                    </span>
                  </div>
                  
                  <div class="addon-preview" *ngIf="form.get('addonBefore')?.value || form.get('addonAfter')?.value">
                    <span *ngIf="form.get('addonBefore')?.value" class="addon-tag prefix">
                      {{ form.get('addonBefore')?.value }}
                    </span>
                    <span class="addon-sample">123</span>
                    <span *ngIf="form.get('addonAfter')?.value" class="addon-tag suffix">
                      {{ form.get('addonAfter')?.value }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="selectedComponentType === 'number'" style="margin-top: 8px;">
              <app-inspector-dependencies
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>
            </div>
  
            <!-- Controles específicos do switch -->
            <div *ngIf="selectedComponentType === 'switch'" class="properties-grid">
              <!-- Valor Padrão -->
              <div class="property-item full-width">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.defaultValue' |translateTA }}
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.defaultValue.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-switch 
                      formControlName="defaultValue"
                      [nzCheckedChildren]="'builderScreen.switch.on' |translateTA"
                      [nzUnCheckedChildren]="'builderScreen.switch.off' |translateTA">
                    </nz-switch>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div class="color-grid" style="grid-column: 1 / -1;">
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.switch.properties.backgroundColor' |translateTA }}</label>
                  <nz-color-picker formControlName="backgroundColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
                <div class="color-item">
                  <label class="color-label">{{ 'builderScreen.switch.properties.textColor' |translateTA }}</label>
                  <nz-color-picker formControlName="textColor" [nzAllowClear]="true" [nzShowText]="true" [nzFormat]="'hex'"></nz-color-picker>
                </div>
              </div>
            </div>
  
            <!-- Controle de Abas do Switch -->
            <div *ngIf="selectedComponentType === 'switch'" class="tab-control-section" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.switch.tabControl.title' |translateTA"></nz-divider>
              
              <div class="properties-grid" formGroupName="tabControl">
                <!-- Toggle para habilitar controle de abas -->
                <div class="property-item">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24">{{ 'builderScreen.switch.tabControl.enabled' |translateTA }}</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <nz-select 
                        formControlName="enabled"
                        (ngModelChange)="onTabControlEnabledChange($event)"
                        style="width: 100%;"
                        [nzPlaceHolder]="'Selecione uma opção...'">
                        <nz-option [nzValue]="false" [nzLabel]="'builderScreen.common.no' |translateTA"></nz-option>
                        <nz-option [nzValue]="true" [nzLabel]="'builderScreen.common.yes' |translateTA"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <!-- Controles condicionais (apenas quando habilitado) -->
                <ng-container *ngIf="form.get('tabControl.enabled')?.value">
                  <!-- Ação quando LIGADO -->
                  <div class="property-item">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{ 'builderScreen.switch.tabControl.onTrueAction' |translateTA }}</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select formControlName="onTrueAction" style="width: 100%;">
                          <nz-option nzValue="show" [nzLabel]="'builderScreen.switch.tabControl.action.show' |translateTA"></nz-option>
                          <nz-option nzValue="hide" [nzLabel]="'builderScreen.switch.tabControl.action.hide' |translateTA"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
  
                  <!-- Ação quando DESLIGADO -->
                  <div class="property-item">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{ 'builderScreen.switch.tabControl.onFalseAction' |translateTA }}</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select formControlName="onFalseAction" style="width: 100%;">
                          <nz-option nzValue="show" [nzLabel]="'builderScreen.switch.tabControl.action.show' |translateTA"></nz-option>
                          <nz-option nzValue="hide" [nzLabel]="'builderScreen.switch.tabControl.action.hide' |translateTA"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
  
                  <!-- Abas alvo -->
                  <div class="property-item">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{ 'builderScreen.switch.tabControl.targetTabs' |translateTA }}</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-select 
                          formControlName="targetTabs" 
                          nzMode="multiple"
                          style="width: 100%;"
                          [nzPlaceHolder]="'builderScreen.switch.tabControl.targetTabs.placeholder' |translateTA">
                          <nz-option 
                            *ngFor="let tab of availableTabs" 
                            [nzValue]="tab.id" 
                            [nzLabel]="tab.name |translateTA"
                            [nzDisabled]="tab.disabled">
                          </nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
  
                  <!-- Modo de controle -->
                  <div class="property-item">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">{{ 'builderScreen.switch.tabControl.mode' |translateTA }}</nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-radio-group formControlName="mode" style="width: 100%;">
                          <label nz-radio nzValue="include">
                            {{ 'builderScreen.switch.tabControl.mode.include' |translateTA }}
                          </label>
                          <label nz-radio nzValue="exclude">
                            {{ 'builderScreen.switch.tabControl.mode.exclude' |translateTA }}
                          </label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
  
                  <!-- Validação de abas -->
                  <div class="property-item" *ngIf="!validateTabControlTargets()">
                    <nz-alert 
                      nzType="warning" 
                      [nzMessage]="'builderScreen.switch.tabControl.validation.noTabs' |translateTA"
                      nzShowIcon>
                    </nz-alert>
                  </div>
                </ng-container>
              </div>

              <app-inspector-dependencies
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>
            </div>

            <!-- Controles específicos de date -->
            <div *ngIf="selectedComponentType === 'date'" class="properties-grid" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.inspector.defaultValue' |translateTA"></nz-divider>
              
              <!-- Valor Padrão para Date -->
              <div class="property-item full-width">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.inspector.defaultValue' |translateTA }}
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.defaultValue.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input nz-input formControlName="defaultValueText" 
                      [placeholder]="'Ex: 2024-01-01'" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <app-inspector-dependencies
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>
            </div>

            <!-- NOVO: Configuração de Opções do Dropdown (Simplificado com Modal) -->
            <div *ngIf="selectedComponentType === 'dropdown'" class="dropdown-options-section-simple" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.inspector.dropdownOptionsTitle' | translateTA"></nz-divider>
              
              <div class="dropdown-options-simple">
                <!-- Botão para abrir modal -->
                <button 
                  nz-button 
                  nzType="default" 
                  nzBlock
                  (click)="openDropdownOptionsModal()"
                  class="config-options-btn">
                  <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
                  {{ 'builderScreen.inspector.dropdownOptionsModal.openButton' | translateTA }}
                </button>
                
                <!-- Contador e Preview das opções -->
                <div class="options-summary" *ngIf="dropdownOptionsArray.length > 0">
                  <div class="options-count">
                    <nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></nz-icon>
                    <span>{{ dropdownOptionsArray.length }} {{ 'builderScreen.inspector.dropdownOptions.configured' | translateTA }}</span>
                  </div>
                  
                  <div class="options-preview-compact">
                    <label>{{ 'builderScreen.inspector.dropdownOptions.preview' | translateTA }}</label>
                    <div class="tags-container">
                      <nz-tag 
                        *ngFor="let opt of dropdownOptionsArray.value" 
                        [nzColor]="'blue'">
                        {{ opt.value }} = {{ opt.label }}
                      </nz-tag>
                    </div>
                  </div>
                </div>
                
                <nz-alert 
                  *ngIf="dropdownOptionsArray.length === 0"
                  nzType="info"
                  nzMessage="{{ 'builderScreen.inspector.dropdownOptions.noOptions' | translateTA }}"
                  nzShowIcon
                  style="margin-top: 12px;">
                </nz-alert>
              </div>
            </div>

            <div *ngIf="selectedComponentType === 'dropdown'" style="margin-top: 8px;">
              <app-inspector-dependencies
                (onOpenDependencies)="openSearchDependencyModal()"
                (onOpenMappings)="openFieldMappingModal()">
              </app-inspector-dependencies>
            </div>
  
            <!-- Controles específicos das abas -->
            <div *ngIf="selectedComponentType === 'tabs'" class="color-sections">
              
              <!-- Seção de Estilo das Abas -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-title">{{ 'builderScreen.tabs.section.tabsStyle' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.backgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="backgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('backgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.textColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="textColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('textColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.activeTabColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="activeTabColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('activeTabColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.activeTabTextColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="activeTabTextColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('activeTabTextColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.borderColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="borderColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('borderColor')">
                    </nz-color-picker>
                  </div>
                </div>
              </div>
  
              <!-- Seção de Estilo do Conteúdo -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-title">{{ 'builderScreen.tabs.section.contentStyle' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.contentBackgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="contentBackgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('contentBackgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.contentTextColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="contentTextColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('contentTextColor')">
                    </nz-color-picker>
                  </div>
                </div>
              </div>
  
              <!-- Seção de Estilo do Container Principal (nz-tabs) -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-icon">📦</span>
                  <span class="section-title">{{ 'builderScreen.tabs.section.containerStyle' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.tabsContainerBackgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="tabsContainerBackgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('tabsContainerBackgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.tabsContainerBorderColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="tabsContainerBorderColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('tabsContainerBorderColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.tabsContainerBorderRadius' |translateTA }}</label>
                    <input 
                      nz-input 
                      formControlName="tabsContainerBorderRadius"
                      (blur)="onBlur('tabsContainerBorderRadius')"
                      placeholder="8px">
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.tabsContainerPadding' |translateTA }}</label>
                    <input 
                      nz-input 
                      formControlName="tabsContainerPadding"
                      (blur)="onBlur('tabsContainerPadding')"
                      placeholder="16px">
                  </div>
                </div>
              </div>
  
              <!-- Seção de Estilo do Wrapper Externo (canvas-node) -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-icon">🎁</span>
                  <span class="section-title">{{ 'builderScreen.tabs.section.wrapperStyle' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.wrapperBackgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="wrapperBackgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('wrapperBackgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.wrapperBorderColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="wrapperBorderColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('wrapperBorderColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.wrapperBorderRadius' |translateTA }}</label>
                    <input 
                      nz-input 
                      formControlName="wrapperBorderRadius"
                      (blur)="onBlur('wrapperBorderRadius')"
                      placeholder="6px">
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.tabs.properties.wrapperPadding' |translateTA }}</label>
                    <input 
                      nz-input 
                      formControlName="wrapperPadding"
                      (blur)="onBlur('wrapperPadding')"
                      placeholder="12px">
                  </div>
                </div>
              </div>
            </div>
  
            <!-- Seção de Ícones das Abas -->
            <div *ngIf="selectedComponentType === 'tabs'" class="tab-icon-section" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.tabs.icon.title' |translateTA"></nz-divider>
              
              <div class="properties-grid">
                <!-- Seletor de Ícone da Aba -->
                <div class="property-item">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24">
                      {{ 'builderScreen.tabs.icon.select' |translateTA }}
                      <nz-icon 
                        nzType="question-circle" 
                        nz-tooltip 
                        [nzTooltipTitle]="'builderScreen.tabs.icon.help' |translateTA"
                        class="help-icon">
                      </nz-icon>
                      <!-- ⭐ Botão para recarregar ícones customizados -->
                      <button 
                        nz-button 
                        nzType="text" 
                        nzSize="small"
                        (click)="reloadCustomIcons()"
                        nz-tooltip
                        [nzTooltipTitle]="'builderScreen.inspector.reloadIcons' | translateTA"
                        style="float: right; padding: 0 4px;">
                        <nz-icon nzType="reload" nzTheme="outline"></nz-icon>
                      </button>
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <nz-select 
                        formControlName="tabIcon"
                        style="width: 100%;"
                        [nzPlaceHolder]="'builderScreen.tabs.icon.placeholder' |translateTA"
                        [nzAllowClear]="true">
                        
                        <!-- Opção "Sem ícone" -->
                        <nz-option nzValue="" [nzLabel]="'builderScreen.tabs.icon.none' |translateTA">
                          <span>{{ 'builderScreen.tabs.icon.none' |translateTA }}</span>
                        </nz-option>
                        
                        <!-- Agrupar por categoria -->
                        <nz-option-group *ngFor="let category of objectKeys(iconCategories)" [nzLabel]="iconCategories[category]">
                          <nz-option 
                            *ngFor="let icon of getIconsByCategory(category)" 
                            [nzValue]="icon.value" 
                            [nzLabel]="icon.label">
                            <div class="icon-option">
                              <!-- ⭐ Ícones customizados usam nz-icon (registrados como "custom:NOME" no NzIconService) -->
                              <nz-icon
                                *ngIf="icon.isCustom"
                                [nzType]="icon.value"
                                class="icon-preview custom-icon">
                              </nz-icon>
                              <!-- Ícones estáticos usam img -->
                              <img 
                                *ngIf="!icon.isCustom"
                                [src]="icon.preview" 
                                [alt]="icon.label" 
                                class="icon-preview">
                              <span>{{ icon.label }}</span>
                            </div>
                          </nz-option>
                        </nz-option-group>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <!-- Preview do Ícone Selecionado -->
                <div class="property-item" *ngIf="form.get('tabIcon')?.value">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24">{{ 'builderScreen.tabs.icon.preview' |translateTA }}</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <div class="icon-preview-container">
                        <!-- ⭐ Ícone customizado -->
                        <nz-icon
                          *ngIf="isCustomIcon(form.get('tabIcon')?.value)"
                          [nzType]="form.get('tabIcon')?.value"
                          class="icon-preview-large custom-icon">
                        </nz-icon>
                        <!-- Ícone estático -->
                        <img 
                          *ngIf="!isCustomIcon(form.get('tabIcon')?.value)"
                          [src]="getIconPreview(form.get('tabIcon')?.value)" 
                          [alt]="'Preview do ícone'"
                          class="icon-preview-large">
                        <span class="icon-preview-text">{{ form.get('label')?.value |translateTA }}</span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
  
            <!-- Seção Barra de Contexto (para tabs) -->
            <div *ngIf="selectedComponentType === 'tabs'" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.inspector.contextBarSection' | translateTA"></nz-divider>
              <button 
                nz-button 
                nzType="default" 
                nzBlock
                (click)="openContextFieldsModal()"
                class="config-options-btn">
                <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
                Configurar Barra de Contexto
              </button>
            </div>

            <!-- Controles específicos do panel -->
            <div *ngIf="selectedComponentType === 'panel'" class="properties-grid" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.panel.section.properties' |translateTA"></nz-divider>
              
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.panel.properties.name' |translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input 
                      nz-input 
                      formControlName="name"
                      (blur)="onBlur('name')"
                      [placeholder]="'builderScreen.panel.properties.name.placeholder' |translateTA">
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{ 'builderScreen.panel.properties.order' |translateTA }}
                    <nz-icon 
                      nzType="question-circle" 
                      nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.panel.properties.order.help' |translateTA"
                      class="help-icon">
                    </nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <div style="display: flex; gap: 8px; align-items: center;">
                      <nz-input-number 
                        formControlName="order"
                        [nzMin]="0"
                        [nzMax]="100"
                        [nzStep]="1"
                        (nzBlur)="onBlur('order')"
                        style="flex: 1;"
                        [nzPlaceHolder]="'builderScreen.panel.properties.order.placeholder' |translateTA">
                      </nz-input-number>
                      <button 
                        nz-button 
                        nzType="default" 
                        nzSize="small"
                        (click)="movePanelUp()"
                        [nzTitle]="'builderScreen.panel.actions.moveUp' |translateTA"
                        nz-tooltip>
                        <nz-icon nzType="arrow-up" nzTheme="outline"></nz-icon>
                      </button>
                      <button 
                        nz-button 
                        nzType="default" 
                        nzSize="small"
                        (click)="movePanelDown()"
                        [nzTitle]="'builderScreen.panel.actions.moveDown' |translateTA"
                        nz-tooltip>
                        <nz-icon nzType="arrow-down" nzTheme="outline"></nz-icon>
                      </button>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="inline-switch-group">
                <div class="inline-switch-item">
                  <span class="switch-label">{{ 'builderScreen.panel.properties.active' |translateTA }}</span>
                  <nz-switch formControlName="active" (ngModelChange)="onBlur('active')" nzSize="small"></nz-switch>
                </div>
                <div class="inline-switch-item">
                  <span class="switch-label">{{ 'builderScreen.panel.properties.disabled' |translateTA }}</span>
                  <nz-switch formControlName="disabled" (ngModelChange)="onBlur('disabled')" nzSize="small"></nz-switch>
                </div>
                <div class="inline-switch-item">
                  <span class="switch-label">{{ 'builderScreen.panel.properties.collapsible' |translateTA }}</span>
                  <nz-switch formControlName="collapsible" (ngModelChange)="onBlur('collapsible')" nzSize="small"></nz-switch>
                </div>
                <div class="inline-switch-item">
                  <span class="switch-label">{{ 'builderScreen.panel.properties.collapsed' |translateTA }}</span>
                  <nz-switch formControlName="collapsed" (ngModelChange)="onBlur('collapsed')" nzSize="small"></nz-switch>
                </div>
              </div>
  
              <!-- Seções de Estilo do Painel -->
              <div class="color-sections">
                
                <!-- Seção de Borda do Painel -->
                <div class="color-section">
                  <div class="section-header">
                    <span class="section-icon">🎨</span>
                    <span class="section-title">{{ 'builderScreen.panel.section.borderStyle' |translateTA }}</span>
                  </div>
                  
                  <div class="color-grid">
                    <div class="color-item">
                      <label class="color-label">{{ 'builderScreen.panel.properties.panelBorderColor' |translateTA }}</label>
                      <nz-color-picker 
                        formControlName="panelBorderColor"
                        [nzAllowClear]="true"
                        [nzShowText]="true"
                        [nzFormat]="'hex'"
                        (nzOnChange)="validateColorInput('panelBorderColor')">
                      </nz-color-picker>
                    </div>
                  </div>
                </div>
  
                <!-- Seção de Estilo do Cabeçalho -->
                <div class="color-section">
                  <div class="section-header">
                    <span class="section-icon">📋</span>
                    <span class="section-title">{{ 'builderScreen.panel.section.headerStyle' |translateTA }}</span>
                  </div>
                  
                  <div class="color-grid">
                    <div class="color-item">
                      <label class="color-label">{{ 'builderScreen.panel.properties.panelHeaderBackgroundColor' |translateTA }}</label>
                      <nz-color-picker 
                        formControlName="panelHeaderBackgroundColor"
                        [nzAllowClear]="true"
                        [nzShowText]="true"
                        [nzFormat]="'hex'"
                        (nzOnChange)="validateColorInput('panelHeaderBackgroundColor')">
                      </nz-color-picker>
                    </div>
  
                    <div class="color-item">
                      <label class="color-label">{{ 'builderScreen.panel.properties.panelHeaderTextColor' |translateTA }}</label>
                      <nz-color-picker 
                        formControlName="panelHeaderTextColor"
                        [nzAllowClear]="true"
                        [nzShowText]="true"
                        [nzFormat]="'hex'"
                        (nzOnChange)="validateColorInput('panelHeaderTextColor')">
                      </nz-color-picker>
                    </div>
                  </div>
                </div>
  
                <!-- Seção de Estilo do Conteúdo -->
                <div class="color-section">
                  <div class="section-header">
                    <span class="section-icon">📄</span>
                    <span class="section-title">{{ 'builderScreen.panel.section.contentStyle' |translateTA }}</span>
                  </div>
                  
                  <div class="color-grid">
                    <div class="color-item">
                      <label class="color-label">{{ 'builderScreen.panel.properties.panelContentBackgroundColor' |translateTA }}</label>
                      <nz-color-picker 
                        formControlName="panelContentBackgroundColor"
                        [nzAllowClear]="true"
                        [nzShowText]="true"
                        [nzFormat]="'hex'"
                        (nzOnChange)="validateColorInput('panelContentBackgroundColor')">
                      </nz-color-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- Controles específicos da tabela -->
            <div *ngIf="selectedComponentType === 'table' || selectedComponentType === 'simpletable'" class="color-sections">
              
              <!-- Seção de Estilo do Cabeçalho -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-title">{{ 'builderScreen.table.section.headerStyle' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.headerBackgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="headerBackgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('headerBackgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.headerTextColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="headerTextColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('headerTextColor')">
                    </nz-color-picker>
                  </div>
                </div>
              </div>
  
              <!-- Seção de Estilo das Linhas -->
              <div class="color-section">
                <div class="section-header">
                  <span class="section-title">{{ 'builderScreen.table.section.rowStyle' |translateTA }}</span>
                </div>
                
                <div class="color-grid">
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.rowBackgroundColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="rowBackgroundColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('rowBackgroundColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.rowTextColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="rowTextColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('rowTextColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.alternateRowColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="alternateRowColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('alternateRowColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.borderColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="borderColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('borderColor')">
                    </nz-color-picker>
                  </div>
  
                  <div class="color-item">
                    <label class="color-label">{{ 'builderScreen.table.properties.hoverColor' |translateTA }}</label>
                    <nz-color-picker 
                      formControlName="hoverColor"
                      [nzAllowClear]="true"
                      [nzShowText]="true"
                      [nzFormat]="'hex'"
                      (nzOnChange)="validateColorInput('hoverColor')">
                    </nz-color-picker>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- ⭐ NOVO: Propriedades específicas do Row -->
            <div *ngIf="selectedComponentType === 'row'" class="properties-grid" style="margin-top: 16px;">
              <nz-divider [nzText]="'builderScreen.inspector.rowSection' | translateTA"></nz-divider>
              
              <div class="compact-info-tip">
                <nz-icon nzType="info-circle" nzTheme="outline"
                  nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.rowHelp' | translateTA"
                  style="color: #1890ff; cursor: help;"></nz-icon>
                <span>Container Horizontal</span>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">{{ 'builderScreen.inspector.fieldGap' | translateTA }}</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="gap" (ngModelChange)="onBlur('gap')">
                      <nz-option nzValue="4px" [nzLabel]="'builderScreen.inspector.gap.small' | translateTA"></nz-option>
                      <nz-option nzValue="8px" [nzLabel]="'builderScreen.inspector.gap.medium' | translateTA"></nz-option>
                      <nz-option nzValue="12px" [nzLabel]="'builderScreen.inspector.gap.normal' | translateTA"></nz-option>
                      <nz-option nzValue="16px" [nzLabel]="'builderScreen.inspector.gap.large' | translateTA"></nz-option>
                      <nz-option nzValue="24px" [nzLabel]="'builderScreen.inspector.gap.extraLarge' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Alinhamento Vertical</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="alignItems" (ngModelChange)="onBlur('alignItems')">
                      <nz-option nzValue="start" [nzLabel]="'builderScreen.inspector.align.top' | translateTA"></nz-option>
                      <nz-option nzValue="center" [nzLabel]="'builderScreen.inspector.align.center' | translateTA"></nz-option>
                      <nz-option nzValue="end" [nzLabel]="'builderScreen.inspector.align.bottom' | translateTA"></nz-option>
                      <nz-option nzValue="stretch" [nzLabel]="'builderScreen.inspector.align.stretch' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Alinhamento Horizontal</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="justifyContent" (ngModelChange)="onBlur('justifyContent')">
                      <nz-option nzValue="start" [nzLabel]="'builderScreen.inspector.justify.start' | translateTA"></nz-option>
                      <nz-option nzValue="center" [nzLabel]="'builderScreen.inspector.align.center' | translateTA"></nz-option>
                      <nz-option nzValue="end" [nzLabel]="'builderScreen.inspector.justify.end' | translateTA"></nz-option>
                      <nz-option nzValue="space-between" [nzLabel]="'builderScreen.inspector.justify.spaceBetween' | translateTA"></nz-option>
                      <nz-option nzValue="space-around" [nzLabel]="'builderScreen.inspector.justify.spaceAround' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
  
              <div class="property-item">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Padding Interno</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="padding" (ngModelChange)="onBlur('padding')">
                      <nz-option nzValue="0" [nzLabel]="'builderScreen.common.none' | translateTA"></nz-option>
                      <nz-option nzValue="4px" [nzLabel]="'builderScreen.inspector.gap.small' | translateTA"></nz-option>
                      <nz-option nzValue="8px" [nzLabel]="'builderScreen.inspector.gap.medium' | translateTA"></nz-option>
                      <nz-option nzValue="12px" [nzLabel]="'builderScreen.inspector.gap.normal' | translateTA"></nz-option>
                      <nz-option nzValue="16px" [nzLabel]="'builderScreen.inspector.gap.large' | translateTA"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </ng-template>
          
          <ng-container *ngTemplateOutlet="essentialContent"></ng-container>
          
          <!-- Controles de Mapeamento de Banco de Dados Específicos do Componente -->
          <div *ngIf="selectedComponentType === 'text' || selectedComponentType === 'textarea' || selectedComponentType === 'number' || selectedComponentType === 'switch'" class="properties-grid" style="margin-top: 16px;">
            <nz-divider [nzText]="'builderScreen.inspector.databaseMapping' |translateTA"></nz-divider>
            
            <!-- Controles de mapeamento de banco de dados -->
            <div class="property-item">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">
                  {{ 'builderScreen.inspector.entityName' |translateTA }}
                  <nz-icon 
                    nzType="question-circle" 
                    nz-tooltip 
                    [nzTooltipTitle]="'builderScreen.inspector.entityName.help' |translateTA"
                    class="help-icon">
                  </nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input 
                    nz-input 
                    formControlName="entityName"
                    [placeholder]="'builderScreen.inspector.entityName.placeholder' |translateTA" />
                </nz-form-control>
              </nz-form-item>
            </div>
  
            <div class="property-item">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">
                  {{ 'builderScreen.inspector.fieldName' |translateTA }}
                  <nz-icon 
                    nzType="question-circle" 
                    nz-tooltip 
                    [nzTooltipTitle]="'builderScreen.inspector.fieldName.help' |translateTA"
                    class="help-icon">
                  </nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input 
                    nz-input 
                    formControlName="fieldName"
                    [placeholder]="'builderScreen.inspector.fieldName.placeholder' |translateTA" />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </nz-collapse-panel>
  
        <!-- Seção de Posição da Grade V3 -->
        <nz-collapse-panel 
          [nzHeader]="'builderScreen.inspector.gridPosition' |translateTA" 
          [nzActive]="false"
          [nzDisabled]="false">
          
          <div class="compact-info-tip">
            <nz-icon nzType="bulb" nzTheme="outline"
              nz-tooltip nzTooltipTitle="50% = 2 campos lado a lado | 33% = 3 campos | 25% = 4 campos. Ex: Campo 75% + Botão 25%"
              style="color: #faad14; cursor: help;"></nz-icon>
            <span>Campos Lado a Lado</span>
          </div>
          
          <div class="grid-position-controls">
            <div class="grid-position-info">
              <nz-tag nzColor="blue">
                <nz-icon nzType="border" nzTheme="outline"></nz-icon>
                {{ 'builderScreen.inspector.currentPosition' |translateTA }}: 
                Row {{ (currentGridPosition?.row || 0) + 1 }}, 
                Col {{ (currentGridPosition?.col || 0) + 1 }}
              </nz-tag>
            </div>
  
            <nz-form-item>
              <nz-form-label [nzSpan]="24">{{ 'builderScreen.inspector.gridRowSpan' |translateTA }}</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <div class="grid-span-controls">
                  <button nz-button nzType="default" nzSize="small" (click)="adjustRowSpan(-1)" [disabled]="(form.get('rowSpan')?.value || 1) <= 1">
                    <nz-icon nzType="minus" nzTheme="outline"></nz-icon>
                  </button>
                  <nz-input-number 
                    [nzMin]="1" 
                    [nzMax]="50"
                    formControlName="rowSpan" 
                    (nzBlur)="onBlur('rowSpan')">
                  </nz-input-number>
                  <button nz-button nzType="default" nzSize="small" (click)="adjustRowSpan(1)" [disabled]="(form.get('rowSpan')?.value || 1) >= 50">
                    <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                  </button>
                </div>
              </nz-form-control>
            </nz-form-item>
  
            <nz-form-item>
              <nz-form-label [nzSpan]="24">
                {{ 'builderScreen.inspector.gridColSpan' |translateTA }}
                <nz-icon 
                  nzType="info-circle" 
                  nzTheme="outline"
                  nz-tooltip
                  [nzTooltipTitle]="'builderScreen.inspector.widthShortcutsHelp' | translateTA"
                  style="margin-left: 4px; color: #1890ff;">
                </nz-icon>
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <!-- ⭐ NOVO: Botões de atalho para larguras comuns -->
                <div class="width-shortcuts" style="margin-bottom: 12px; display: flex; gap: 6px;">
                  <button 
                    nz-button 
                    [nzType]="(form.get('colSpan')?.value === 24) ? 'primary' : 'default'"
                    nzSize="small"
                    (click)="setColSpan(24)"
                    style="flex: 1; font-size: 11px; height: 48px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 4px;">
                    <span style="display: block; font-weight: 600; line-height: 1.2;">100%</span>
                    <span style="font-size: 10px; opacity: 0.7; line-height: 1.2;">Total</span>
                  </button>
                  <button 
                    nz-button 
                    [nzType]="(form.get('colSpan')?.value === 18) ? 'primary' : 'default'"
                    nzSize="small"
                    (click)="setColSpan(18)"
                    style="flex: 1; font-size: 11px; height: 48px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 4px;">
                    <span style="display: block; font-weight: 600; line-height: 1.2;">75%</span>
                    <span style="font-size: 10px; opacity: 0.7; line-height: 1.2;">3/4</span>
                  </button>
                  <button 
                    nz-button 
                    [nzType]="(form.get('colSpan')?.value === 12) ? 'primary' : 'default'"
                    nzSize="small"
                    (click)="setColSpan(12)"
                    style="flex: 1; font-size: 11px; height: 48px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 4px;">
                    <span style="display: block; font-weight: 600; line-height: 1.2;">50%</span>
                    <span style="font-size: 10px; opacity: 0.7; line-height: 1.2;">Metade</span>
                  </button>
                  <button 
                    nz-button 
                    [nzType]="(form.get('colSpan')?.value === 8) ? 'primary' : 'default'"
                    nzSize="small"
                    (click)="setColSpan(8)"
                    style="flex: 1; font-size: 11px; height: 48px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 4px;">
                    <span style="display: block; font-weight: 600; line-height: 1.2;">33%</span>
                    <span style="font-size: 10px; opacity: 0.7; line-height: 1.2;">1/3</span>
                  </button>
                  <button 
                    nz-button 
                    [nzType]="(form.get('colSpan')?.value === 6) ? 'primary' : 'default'"
                    nzSize="small"
                    (click)="setColSpan(6)"
                    style="flex: 1; font-size: 11px; height: 48px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 4px;">
                    <span style="display: block; font-weight: 600; line-height: 1.2;">25%</span>
                    <span style="font-size: 10px; opacity: 0.7; line-height: 1.2;">1/4</span>
                  </button>
                </div>
  
                <!-- ⭐ Preview visual da grade -->
                <div class="grid-preview" style="margin-bottom: 12px; padding: 8px; background: #f5f5f5; border-radius: 4px;">
                  <div style="font-size: 11px; color: #666; margin-bottom: 4px; text-align: center;">
                    <strong>{{ form.get('colSpan')?.value || 24 }}</strong> de 24 colunas
                  </div>
                  <div style="display: flex; gap: 2px; height: 20px;">
                    <div 
                      *ngFor="let col of [].constructor(form.get('colSpan')?.value || 24); let i = index"
                      style="flex: 1; background: #1890ff; border-radius: 2px;">
                    </div>
                    <div 
                      *ngFor="let col of [].constructor(24 - (form.get('colSpan')?.value || 24)); let i = index"
                      style="flex: 1; background: #e8e8e8; border-radius: 2px;">
                    </div>
                  </div>
                </div>
  
                <!-- Controle numérico existente -->
                <div class="grid-span-controls">
                  <button nz-button nzType="default" nzSize="small" (click)="adjustColSpan(-1)" [disabled]="(form.get('colSpan')?.value || 1) <= 1">
                    <nz-icon nzType="minus" nzTheme="outline"></nz-icon>
                  </button>
                  <nz-input-number 
                    [nzMin]="1" 
                    [nzMax]="24"
                    formControlName="colSpan" 
                    (nzBlur)="onBlur('colSpan')">
                  </nz-input-number>
                  <button nz-button nzType="default" nzSize="small" (click)="adjustColSpan(1)" [disabled]="(form.get('colSpan')?.value || 1) >= 24">
                    <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                  </button>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-collapse-panel>
  
        <!-- Configurações Avançadas (Agrupadas por Categoria) -->
        <nz-collapse-panel 
          *ngIf="hasAdvancedProperties(selectedComponentType)"
          [nzHeader]="'builderScreen.inspector.advancedSettings' |translateTA" 
          [nzActive]="false"
          [nzDisabled]="false">
          
          <!-- Propriedades Avançadas por Grupo -->
          <nz-collapse [nzBordered]="false" class="nested-collapse">
            <nz-collapse-panel 
              *ngFor="let group of propertyGroups" 
              [nzHeader]="group.titleKey |translateTA"
              [nzActive]="false"
              [nzDisabled]="!hasPropertiesInGroup(group.id)">
              
              <ng-template #groupIcon>
                <nz-icon [nzType]="group.icon" nzTheme="outline"></nz-icon>
              </ng-template>
              
              <div class="property-group">
                <div class="group-description">{{ group.description }}</div>
                
                <div class="properties-grid">
                  <div *ngFor="let property of getPropertiesInGroup(group.id)" class="property-item">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24">
                        <span class="property-label">
                          {{ property.labelKey |translateTA }}
                          <nz-icon 
                            *ngIf="property.helpTextKey" 
                            nzType="question-circle" 
                            nz-tooltip 
                            [nzTooltipTitle]="property.helpTextKey |translateTA"
                            class="help-icon">
                          </nz-icon>
                        </span>
                      </nz-form-label>
                      
                      <nz-form-control [nzSpan]="24">
                        <!-- Mesmos controles de formulário dinâmicos da seção essencial -->
                        <input 
                          *ngIf="property.type === 'text'" 
                          nz-input 
                          [formControlName]="property.key" 
                          (blur)="onBlur(property.key)" />
                        
                        <textarea 
                          *ngIf="property.type === 'textarea'" 
                          nz-input 
                          [formControlName]="property.key" 
                          (blur)="onBlur(property.key)"
                          [nzAutosize]="{ minRows: 2, maxRows: 6 }">
                        </textarea>
                        
                        <nz-input-number 
                          *ngIf="property.type === 'number'" 
                          [formControlName]="property.key"
                          [nzMin]="property.min"
                          [nzMax]="property.max"
                          [nzStep]="property.step || 1"
                          (nzBlur)="onBlur(property.key)"
                          style="width: 100%">
                        </nz-input-number>
                        
                        <label 
                          *ngIf="property.type === 'checkbox'" 
                          nz-checkbox 
                          [formControlName]="property.key">
                          {{ property.labelKey |translateTA }}
                        </label>
                        
                        <nz-select 
                          *ngIf="property.type === 'select'" 
                          [formControlName]="property.key"
                          (ngModelChange)="onBlur(property.key)">
                          <nz-option 
                            *ngFor="let option of property.options" 
                            [nzValue]="option.value" 
                            [nzLabel]="option.label">
                          </nz-option>
                        </nz-select>
                        
                        <input 
                          *ngIf="property.type === 'color'" 
                          type="color" 
                          nz-input 
                          [formControlName]="property.key" 
                          (blur)="onBlur(property.key)" />
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </nz-collapse-panel>
  
        <!-- Seção de Configuração de Colunas (para Tabelas) -->
        <nz-collapse-panel 
          *ngIf="selectedComponentType === 'table' || selectedComponentType === 'simpletable'"
          [nzHeader]="'builderScreen.inspector.columnConfiguration' |translateTA" 
          [nzActive]="false"
          [nzDisabled]="false">
          
          <nz-form-item>
            <nz-form-label [nzSpan]="24">{{ 'builderScreen.inspector.columns' |translateTA }}</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <button nz-button nzType="dashed" (click)="addColumn()" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.addColumn' |translateTA">
                <nz-icon nzType="plus"></nz-icon>
                {{ 'builderScreen.inspector.addColumn' |translateTA }}
              </button>
            </nz-form-control>
          </nz-form-item>
  
          <div formArrayName="columns">
            <nz-form-item *ngFor="let column of columnsArray.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i">
              <nz-form-control [nzSpan]="24">
                <div class="column-config-row">
                  <input nz-input placeholder="{{ 'builderScreen.inspector.columnKey' |translateTA }}" formControlName="key" style="flex: 1;">
                  <input nz-input placeholder="{{ 'builderScreen.inspector.columnLabel' |translateTA }}" formControlName="label" style="flex: 1;">
                  <nz-select formControlName="type" style="width: 80px;">
                    <nz-option nzValue="text" [nzLabel]="'builderScreen.common.text' | translateTA"></nz-option>
                    <nz-option nzValue="number" [nzLabel]="'builderScreen.common.number' | translateTA"></nz-option>
                    <nz-option nzValue="boolean" [nzLabel]="'builderScreen.common.boolean' | translateTA"></nz-option>
                    <nz-option nzValue="date" [nzLabel]="'builderScreen.common.date' | translateTA"></nz-option>
                  </nz-select>
                  <label nz-checkbox formControlName="sortable" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.sortable' |translateTA">S</label>
                  <label nz-checkbox formControlName="filterable" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.filterable' |translateTA">F</label>
                  <button nz-button nzType="text" nzDanger (click)="removeColumn(i)" nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.removeColumn' |translateTA">
                    <nz-icon nzType="delete"></nz-icon>
                  </button>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-collapse-panel>
  
        <!-- Seção de Configuração de DataGrid -->
        <nz-collapse-panel 
          *ngIf="selectedComponentType === 'datagrid'"
          [nzHeader]="'Data Grid Configuration' |translateTA" 
          [nzActive]="true"
          [nzDisabled]="false">
          
          <nz-tabset nzSize="small" nzType="card" class="datagrid-tabs">
            <!-- Tab Geral -->
            <nz-tab [nzTitle]="'builderScreen.common.general' | translateTA">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">
                  <span>{{ 'builderScreen.datagrid.properties.label' |translateTA }}</span>
                  <nz-icon nzType="question-circle" nz-tooltip
                    [nzTooltipTitle]="'builderScreen.datagrid.properties.label.help' |translateTA"
                    class="help-icon"></nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input formControlName="label"
                    [placeholder]="'builderScreen.datagrid.properties.label.placeholder' |translateTA" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSpan]="24">
                  <span>Data Path (Array)</span>
                  <nz-icon nzType="question-circle" nz-tooltip
                    [nzTooltipTitle]="'builderScreen.inspector.gridDataPathHelp' | translateTA"
                    class="help-icon"></nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input formControlName="dataPath" [placeholder]="'builderScreen.inspector.placeholder.dataPath' | translateTA" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-control [nzSpan]="24">
                  <label nz-checkbox formControlName="previewMode"
                    nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.previewHelp' | translateTA">
                    Preview com Dados Fake
                  </label>
                </nz-form-control>
              </nz-form-item>

              <div class="inline-toggle-group" style="margin: 8px 0;">
                <div class="inline-toggle-item">
                  <label nz-checkbox formControlName="enablePagination">Pagination</label>
                </div>
                <div class="inline-toggle-item">
                  <label nz-checkbox formControlName="enableSorting">Sorting</label>
                </div>
                <div class="inline-toggle-item">
                  <label nz-checkbox formControlName="enableFilters">Filters</label>
                </div>
                <div class="inline-toggle-item">
                  <label nz-checkbox formControlName="enableCRUD">
                    {{ 'builderScreen.inspector.dataGrid.enableCRUD' | translateTA }}
                  </label>
                </div>
              </div>

              <nz-form-item *ngIf="form.get('enablePagination')?.value">
                <nz-form-label [nzSpan]="24">Page Size</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number formControlName="pageSize" [nzMin]="1" [nzMax]="100" style="width: 100%;"></nz-input-number>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSpan]="24">
                  Linhas Visíveis
                  <nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip
                    [nzTooltipTitle]="'builderScreen.inspector.maxRowsHelp' | translateTA"
                    style="margin-left: 4px; color: #1890ff; cursor: help;"></nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number formControlName="maxVisibleRows" [nzMin]="0" [nzMax]="100" [nzStep]="1"
                    [nzPlaceHolder]="'0 = sem limite'" style="width: 100%;"></nz-input-number>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSpan]="24">Selection Mode</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-select formControlName="selectionMode" style="width: 100%;">
                    <nz-option nzValue="none" [nzLabel]="'builderScreen.common.none' | translateTA"></nz-option>
                    <nz-option nzValue="single" [nzLabel]="'builderScreen.inspector.selection.single' | translateTA"></nz-option>
                    <nz-option nzValue="multiple" [nzLabel]="'builderScreen.inspector.selection.multiple' | translateTA"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </nz-tab>

            <!-- Tab Colunas -->
            <nz-tab [nzTitle]="columnsTabTitle">
              <ng-template #columnsTabTitle>
                Colunas <nz-tag nzColor="blue" style="margin-left: 4px;">{{ getCurrentDataGridColumns().length }}</nz-tag>
              </ng-template>

              <div style="display: flex; gap: 6px; margin-bottom: 8px;">
                <button nz-button nzType="primary" nzSize="small"
                  (click)="openSmartColumnBuilder()" style="flex: 1;">
                  <nz-icon nzType="thunderbolt"></nz-icon> Smart Builder
                </button>
                <button nz-button nzType="default" nzSize="small"
                  (click)="openColumnManager()" style="flex: 1;">
                  <nz-icon nzType="setting"></nz-icon> Gerenciar
                </button>
              </div>
              <div class="compact-info-tip">
                <nz-icon nzType="info-circle" nzTheme="outline" style="color: #1890ff;"></nz-icon>
                <span nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.columnsHelp' | translateTA">Dica: Smart Builder detecta colunas do JSON</span>
              </div>

              <div formArrayName="columns" style="display: none;">
                <div *ngFor="let column of dataGridColumnsArray.controls; let i = index; trackBy: trackByIndex" 
                     [formGroupName]="i">
                  <input formControlName="field" />
                  <input formControlName="header" />
                  <input formControlName="type" />
                  <input formControlName="dataPath" />
                  <input formControlName="width" />
                  <input formControlName="sortable" />
                  <input formControlName="filterable" />
                  <input formControlName="editable" />
                </div>
              </div>
            </nz-tab>

            <!-- Tab Master-Detail -->
            <nz-tab [nzTitle]="'builderScreen.inspector.masterDetail' | translateTA">
              <nz-form-item>
                <nz-form-control [nzSpan]="24">
                  <label nz-checkbox formControlName="enableMasterDetail">
                    <nz-icon nzType="link" nzTheme="outline" style="margin-right: 4px;"></nz-icon>
                    Conectar ao Formulário
                    <nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip
                      [nzTooltipTitle]="'builderScreen.inspector.masterDetailHelp' | translateTA"
                      style="margin-left: 4px; color: #1890ff; cursor: help;"></nz-icon>
                  </label>
                </nz-form-control>
              </nz-form-item>

              <ng-container *ngIf="form.get('enableMasterDetail')?.value">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    Panel (Single)
                    <nz-icon nzType="question-circle" nz-tooltip
                      [nzTooltipTitle]="'builderScreen.inspector.singlePanelHelp' | translateTA"
                      class="help-icon"></nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="masterDetailFormPanel" 
                      [nzPlaceHolder]="'builderScreen.inspector.selectPanel' | translateTA"
                      nzShowSearch nzAllowClear style="width: 100%;">
                      <nz-option *ngFor="let panel of getAvailablePanels()" 
                        [nzValue]="panel.id" [nzLabel]="panel.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    Multi-Panel
                    <nz-icon nzType="question-circle" nz-tooltip 
                      [nzTooltipTitle]="'builderScreen.inspector.multiPanelHelp' | translateTA"
                      style="margin-left: 4px; color: #1890ff; cursor: help;"></nz-icon>
                  </nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select formControlName="masterDetailFormPanels" 
                      nzMode="multiple" [nzPlaceHolder]="'builderScreen.inspector.selectPanels' | translateTA"
                      nzShowSearch nzAllowClear style="width: 100%;">
                      <nz-option *ngFor="let panel of getAvailablePanels()" 
                        [nzValue]="panel.id" [nzLabel]="panel.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-control [nzSpan]="24">
                    <label nz-checkbox formControlName="masterDetailAutoGenerate"
                      nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.generateFieldsHelp' | translateTA">
                      Auto-gerar Campos
                    </label>
                  </nz-form-control>
                </nz-form-item>

                <nz-alert
                  *ngIf="form.get('masterDetailFormPanel')?.value || form.get('masterDetailFormPanels')?.value?.length > 0"
                  nzType="success" [nzMessage]="'builderScreen.inspector.configActive' | translateTA"
                  [nzDescription]="getMasterDetailStatusMessage()" nzShowIcon
                  style="margin-top: 8px;">
                </nz-alert>
              </ng-container>
            </nz-tab>

            <!-- Tab Avançado -->
            <nz-tab [nzTitle]="'builderScreen.common.advanced' | translateTA">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">
                  Modo de Visualização
                  <nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip
                    [nzTooltipTitle]="'builderScreen.inspector.viewModeHelp' | translateTA"
                    style="margin-left: 4px; color: #1890ff; cursor: help;"></nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-select formControlName="viewMode" style="width: 100%;">
                    <nz-option nzValue="inline" [nzLabel]="'builderScreen.inspector.viewMode.inline' | translateTA"></nz-option>
                    <nz-option nzValue="flip" [nzLabel]="'builderScreen.inspector.viewMode.flip' | translateTA"></nz-option>
                    <nz-option nzValue="drawer" [nzLabel]="'builderScreen.inspector.viewMode.drawer' | translateTA"></nz-option>
                    <nz-option nzValue="spreadsheet" [nzLabel]="'builderScreen.inspector.viewMode.spreadsheet' | translateTA"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item *ngIf="form.get('viewMode')?.value === 'drawer'">
                <nz-form-label [nzSpan]="24">
                  Largura (%)
                  <nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip
                    [nzTooltipTitle]="'builderScreen.inspector.drawerWidthHelp' | translateTA"
                    style="margin-left: 4px; color: #1890ff; cursor: help;"></nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number formControlName="drawerWidth"
                    [nzMin]="10" [nzMax]="90" [nzStep]="5" style="width: 100%;"></nz-input-number>
                </nz-form-control>
              </nz-form-item>

              <div class="compact-info-tip" *ngIf="form.get('viewMode')?.value === 'flip'" style="margin-top: 6px;">
                <nz-icon nzType="swap" nzTheme="outline" style="color: #faad14;"></nz-icon>
                <span nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.viewMode.flipHelp' | translateTA">Double-Face</span>
              </div>
              <div class="compact-info-tip" *ngIf="form.get('viewMode')?.value === 'drawer'" style="margin-top: 6px;">
                <nz-icon nzType="menu-fold" nzTheme="outline" style="color: #faad14;"></nz-icon>
                <span nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.viewMode.drawerHelp' | translateTA">Gaveta Lateral</span>
              </div>
              <div class="compact-info-tip" *ngIf="form.get('viewMode')?.value === 'spreadsheet'" style="margin-top: 6px;">
                <nz-icon nzType="table" nzTheme="outline" style="color: #faad14;"></nz-icon>
                <span nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.viewMode.spreadsheetHelp' | translateTA">Planilha Inteligente</span>
              </div>

              <nz-divider nzOrientation="left" [nzText]="'builderScreen.inspector.autoAddSection' | translateTA"></nz-divider>

              <nz-form-item>
                <nz-form-control [nzSpan]="24">
                  <label nz-checkbox formControlName="autoAddFirstRow"
                    nz-tooltip [nzTooltipTitle]="'builderScreen.inspector.autoAddHelp' | translateTA">
                    Auto-adicionar 1ª linha
                  </label>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item *ngIf="form.get('autoAddFirstRow')?.value">
                <nz-form-label [nzSpan]="24">
                  Ordem
                  <nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip
                    [nzTooltipTitle]="'builderScreen.inspector.autoAddOrderHelp' | translateTA"
                    style="margin-left: 4px; color: #1890ff; cursor: help;"></nz-icon>
                </nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number formControlName="autoAddOrder"
                    [nzMin]="0" [nzMax]="99" [nzStep]="1" style="width: 100%;"></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </nz-tab>
          </nz-tabset>
        </nz-collapse-panel>
  
        <!-- Seção de Prévia das Propriedades -->
        <nz-collapse-panel 
          [nzHeader]="'builderScreen.inspector.preview' |translateTA"
          [nzActive]="false"
          [nzDisabled]="false">
          
          <div class="property-preview">
            <div class="preview-label">{{ 'builderScreen.inspector.preview.label' |translateTA }}</div>
            
            <!-- Prévia dinâmica do componente baseada nas propriedades atuais -->
            <div class="preview-container">
              <ng-container [ngSwitch]="selectedComponentType">
                
                <div *ngSwitchCase="'text'" class="preview-component">
                  <nz-form-item>
                    <nz-form-label>{{ form.get('label')?.value || 'Label' }}</nz-form-label>
                    <nz-form-control>
                      <input 
                        nz-input 
                        [placeholder]="form.get('placeholder')?.value || 'Placeholder'"
                        [disabled]="true"
                        [ngStyle]="{
                          'background-color': form.get('backgroundColor')?.value || null,
                          'color': form.get('textColor')?.value || null,
                          'pointer-events': 'none'
                        }" />
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchCase="'textarea'" class="preview-component">
                  <nz-form-item>
                    <nz-form-label>{{ form.get('label')?.value || 'Textarea Label' }}</nz-form-label>
                    <nz-form-control>
                      <textarea 
                        nz-input 
                        [placeholder]="form.get('placeholder')?.value || 'Placeholder'"
                        [disabled]="true"
                        [nzAutosize]="{ minRows: form.get('minRows')?.value || 4 }"
                        [ngStyle]="{
                          'background-color': form.get('backgroundColor')?.value || null,
                          'color': form.get('textColor')?.value || null,
                          'pointer-events': 'none'
                        }">
                      </textarea>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchCase="'number'" class="preview-component">
                  <nz-form-item>
                    <nz-form-label>{{ form.get('label')?.value || 'Number Label' }}</nz-form-label>
                    <nz-form-control>
                      <nz-input-number 
                        [nzPlaceHolder]="form.get('placeholder')?.value || '0'"
                        [nzMin]="form.get('min')?.value"
                        [nzMax]="form.get('max')?.value"
                        [nzStep]="form.get('step')?.value || 1"
                        [nzDisabled]="true"
                        [ngStyle]="{
                          'background-color': form.get('backgroundColor')?.value || null,
                          'color': form.get('textColor')?.value || null,
                          'width': '100%'
                        }">
                      </nz-input-number>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchCase="'switch'" class="preview-component">
                  <nz-form-item 
                    [ngStyle]="{
                      'background-color': form.get('backgroundColor')?.value || null,
                      'color': form.get('textColor')?.value || null
                    }">
                    <nz-form-label>{{ form.get('label')?.value || 'Switch Label' }}</nz-form-label>
                    <nz-form-control>
                      <nz-switch 
                        [nzDisabled]="true"
                        [nzCheckedChildren]="form.get('checkedChildren')?.value || 'On'"
                        [nzUnCheckedChildren]="form.get('unCheckedChildren')?.value || 'Off'">
                      </nz-switch>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchCase="'date'" class="preview-component">
                  <nz-form-item>
                    <nz-form-label>{{ form.get('label')?.value || 'Date Label' }}</nz-form-label>
                    <nz-form-control>
                      <nz-date-picker 
                        [nzFormat]="form.get('dateFormat')?.value || 'DD/MM/YYYY'"
                        [nzShowTime]="form.get('showTime')?.value || false"
                        [nzDisabled]="true"
                        style="width: 100%;">
                      </nz-date-picker>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchCase="'select'" class="preview-component">
                  <nz-form-item>
                    <nz-form-label>{{ form.get('label')?.value || 'Select Label' }}</nz-form-label>
                    <nz-form-control>
                      <nz-select 
                        [nzPlaceHolder]="form.get('placeholder')?.value || 'Select an option'"
                        [nzMode]="form.get('multiple')?.value ? 'multiple' : 'default'"
                        [nzShowSearch]="form.get('showSearch')?.value || false"
                        [nzDisabled]="true"
                        style="width: 100%;">
                        <nz-option nzValue="option1" [nzLabel]="'builderScreen.inspector.sampleOption1' | translateTA"></nz-option>
                        <nz-option nzValue="option2" [nzLabel]="'builderScreen.inspector.sampleOption2' | translateTA"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchCase="'divider'" class="preview-component">
                  <nz-divider 
                    [nzDashed]="form.get('dashed')?.value || false"
                    [nzType]="form.get('dividerType')?.value || 'horizontal'"
                    [nzOrientation]="form.get('orientation')?.value || 'center'"
                    [ngStyle]="{'border-color': form.get('color')?.value || '#d9d9d9'}">
                    {{ form.get('label')?.value || 'Divider' }}
                  </nz-divider>
                </div>
  
                <!-- Prévia do Botão -->
                <div *ngSwitchCase="'button'" class="preview-component">
                  <nz-form-item>
                    <nz-form-label>{{ form.get('label')?.value || 'Button Label' }}</nz-form-label>
                    <nz-form-control>
                      <button 
                        nz-button 
                        [nzType]="form.get('buttonType')?.value || 'default'"
                        [nzSize]="form.get('size')?.value || 'default'"
                        [nzLoading]="form.get('loading')?.value || false"
                        [disabled]="form.get('disabled')?.value || true"
                        [ngStyle]="{
                          'background-color': form.get('backgroundColor')?.value || null,
                          'color': form.get('textColor')?.value || null,
                          'border-color': form.get('backgroundColor')?.value || null,
                          'pointer-events': 'none'
                        }">
                        <nz-icon *ngIf="form.get('icon')?.value" [nzType]="form.get('icon')?.value"></nz-icon>
                        {{ form.get('text')?.value || 'Button Text' }}
                      </button>
                    </nz-form-control>
                  </nz-form-item>
                </div>
  
                <div *ngSwitchDefault class="preview-component">
                  <nz-empty [nzNotFoundContent]="'Preview not available for this component type'"></nz-empty>
                </div>
  
              </ng-container>
            </div>
          </div>
        </nz-collapse-panel>
  
      </nz-collapse>
    </form>
  
    <!-- Estado Sem Seleção -->
    <div *ngIf="!selectedComponentType" class="no-selection">
      <nz-empty 
        [nzNotFoundContent]="'builderScreen.inspector.noSelection' |translateTA"
        [nzNotFoundImage]="'simple'">
      </nz-empty>
    </div>
  </div>
  
  <!-- Smart Column Builder Modal -->
  <app-smart-column-builder
    [(visible)]="smartColumnBuilderVisible"
    [currentColumns]="getCurrentDataGridColumns()"
    [formNodes]="getFormNodesForCurrentGrid()"
    (columnsGenerated)="onSmartColumnsGenerated($event)">
  </app-smart-column-builder>
  
  <!-- Column Manager Modal -->
  <app-column-manager
    [(visible)]="columnManagerVisible"
    [columns]="getCurrentDataGridColumns()"
    (columnsChange)="onColumnsChanged($event)">
  </app-column-manager>

  <!-- Modal: Importar campos para o container selecionado -->
  <nz-modal
    [(nzVisible)]="showImportFieldsModal"
    [nzTitle]="importModalTitle"
    nzWidth="620px"
    [nzFooter]="importModalFooter"
    (nzOnCancel)="showImportFieldsModal = false"
    nzClassName="import-fields-modal">

    <ng-template #importModalTitle>
      <div style="display: flex; align-items: center; gap: 10px;">
        <nz-icon nzType="import" nzTheme="outline" style="font-size: 18px; color: #1890ff;"></nz-icon>
        <span style="font-size: 15px; font-weight: 600;">Importar campos</span>
        <nz-tag *ngIf="selectedImportCount > 0" nzColor="processing" style="margin-left: auto;">
          {{ selectedImportCount }} selecionado{{ selectedImportCount !== 1 ? 's' : '' }}
        </nz-tag>
      </div>
    </ng-template>

    <ng-template #importModalFooter>
      <div style="display: flex; align-items: center; gap: 12px;">
        <label nz-checkbox
               [nzChecked]="selectedImportCount === totalImportItems && totalImportItems > 0"
               [nzIndeterminate]="selectedImportCount > 0 && selectedImportCount < totalImportItems"
               (nzCheckedChange)="selectAllImportItems($event)"
               style="margin-right: auto;">
          Selecionar todos
        </label>
        <button nz-button (click)="showImportFieldsModal = false">Cancelar</button>
        <button nz-button nzType="primary" [disabled]="selectedImportCount === 0"
                (click)="confirmImportFields()">
          <nz-icon nzType="import" nzTheme="outline"></nz-icon>
          Importar {{ selectedImportCount > 0 ? '(' + selectedImportCount + ')' : '' }}
        </button>
      </div>
    </ng-template>

    <ng-container *nzModalContent>
      <!-- Search bar -->
      <nz-input-group [nzPrefix]="prefixIconSearch" nzSize="large"
                      style="margin-bottom: 16px; border-radius: 8px;">
        <input nz-input [placeholder]="'builderScreen.inspector.filterFields' | translateTA" [(ngModel)]="importSearchText"
               style="font-size: 13px;" />
      </nz-input-group>
      <ng-template #prefixIconSearch>
        <nz-icon nzType="search" style="color: #8c8c8c;"></nz-icon>
      </ng-template>

      <!-- Grouped panels -->
      <div style="max-height: 420px; overflow-y: auto; border-radius: 8px;">
        <nz-collapse *ngIf="importGroups.length > 0" nzBordered [nzGhost]="false">
          <ng-container *ngFor="let group of importGroups">
            <nz-collapse-panel
              *ngIf="getFilteredGroupItems(group).length > 0"
              [nzActive]="group.expanded"
              [nzHeader]="panelHeaderTpl"
              [nzExtra]="panelExtraTpl"
              (nzActiveChange)="group.expanded = $event"
              style="margin-bottom: 2px;">

              <ng-template #panelHeaderTpl>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <nz-icon nzType="appstore" nzTheme="outline" style="color: #1890ff;"></nz-icon>
                  <span style="font-weight: 600;">{{ group.panelName }}</span>
                  <nz-tag *ngIf="group.tabLabel" nzColor="geekblue" style="font-size: 10px; line-height: 18px;">
                    {{ group.tabLabel }}
                  </nz-tag>
                </div>
              </ng-template>

              <ng-template #panelExtraTpl>
                <label nz-checkbox
                       [nzChecked]="isGroupAllSelected(group)"
                       [nzIndeterminate]="isGroupIndeterminate(group)"
                       (click)="$event.stopPropagation()"
                       (nzCheckedChange)="toggleGroupSelection(group, $event)">
                </label>
              </ng-template>

              <div *ngFor="let item of getFilteredGroupItems(group)"
                   style="padding: 0; margin: 0;">
                <!-- Row item -->
                <div *ngIf="item.isRow"
                     (click)="toggleImportItem(item)"
                     style="display: flex; align-items: flex-start; gap: 10px; padding: 10px 12px; cursor: pointer; border-radius: 6px; margin-bottom: 4px; transition: background 0.15s;"
                     [style.background]="item.selected ? 'rgba(250, 173, 20, 0.1)' : 'transparent'"
                     [style.border]="item.selected ? '1px solid rgba(250, 173, 20, 0.3)' : '1px solid transparent'">
                  <label nz-checkbox [nzChecked]="item.selected"
                         (click)="$event.stopPropagation()"
                         (nzCheckedChange)="item.selected = $event"
                         style="margin-top: 2px;"></label>
                  <div style="flex: 1; min-width: 0;">
                    <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
                      <nz-icon nzType="column-width" nzTheme="outline" style="color: #faad14; font-size: 15px;"></nz-icon>
                      <span style="font-weight: 600;">{{ item.label }}</span>
                      <nz-tag nzColor="warning" style="font-size: 10px; line-height: 18px;">
                        ROW
                      </nz-tag>
                      <span style="font-size: 11px; color: #8c8c8c;">
                        {{ item.childCount }} campo{{ item.childCount !== 1 ? 's' : '' }} dentro
                      </span>
                    </div>
                    <div *ngIf="item.children && item.children.length > 0"
                         style="display: flex; flex-wrap: wrap; gap: 4px; padding-left: 4px;">
                      <nz-tag *ngFor="let child of item.children"
                              style="font-size: 10px; line-height: 16px; border-radius: 4px; margin: 0;">
                        <nz-icon [nzType]="getTypeIcon(child.type)" nzTheme="outline"
                                 [style.color]="getTypeColor(child.type)"
                                 style="margin-right: 3px; font-size: 10px;"></nz-icon>
                        {{ child.label }}
                      </nz-tag>
                    </div>
                  </div>
                </div>

                <!-- Regular field item -->
                <div *ngIf="!item.isRow"
                     (click)="toggleImportItem(item)"
                     style="display: flex; align-items: center; gap: 10px; padding: 8px 12px; cursor: pointer; border-radius: 6px; margin-bottom: 2px; transition: background 0.15s;"
                     [style.background]="item.selected ? 'rgba(24, 144, 255, 0.08)' : 'transparent'"
                     [style.border]="item.selected ? '1px solid rgba(24, 144, 255, 0.2)' : '1px solid transparent'">
                  <label nz-checkbox [nzChecked]="item.selected"
                         (click)="$event.stopPropagation()"
                         (nzCheckedChange)="item.selected = $event"></label>
                  <nz-icon [nzType]="getTypeIcon(item.type)" nzTheme="outline"
                           [style.color]="getTypeColor(item.type)"
                           style="font-size: 15px;"></nz-icon>
                  <span style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500;">
                    {{ item.label }}
                  </span>
                  <nz-tag [nzColor]="getTypeColor(item.type)"
                          style="font-size: 10px; line-height: 18px; border-radius: 4px; opacity: 0.85;">
                    {{ item.type }}
                  </nz-tag>
                </div>
              </div>
            </nz-collapse-panel>
          </ng-container>
        </nz-collapse>

        <nz-empty *ngIf="totalImportItems === 0"
                  [nzNotFoundContent]="'builderScreen.inspector.noFieldsToImport' | translateTA"
                  style="padding: 40px;">
        </nz-empty>
      </div>
    </ng-container>
  </nz-modal>